// extracted by mini-css-extract-plugin
export default {"root":"account_root__H75Y8","contain":"account_contain__HgJHi","espace_haut":"account_espace_haut__FYtIS","espace_bas":"account_espace_bas__mRnCc"};